import AppService from '../shared/App.api';

export default {
  getTemplates,
  getTemplate,
  getTopics,
  uploadTemplateMedia,
  createTemplate,
  editTemplate,
  createTopic,
  createSubtopic,
  deleteTemplate,
  endTemplates,
};

const templatesUrl = '/admin/templates';
const topicsUrl = '/admin/topics';

async function getTemplates() {
  try {
    const response = await AppService.get(templatesUrl);
    return response.data.data;
  } catch (error) {
    throw new Error('Failed to get templates');
  }
}

async function getTemplate(id) {
  if (!id) {
    throw new Error('Template ID is required');
  }

  const templates = await getTemplates();
  const template = templates.find((item) => item.id === id);

  if (!template) {
    throw new Error('Template not found');
  }

  return template;
}

async function getTopics() {
  try {
    const response = await AppService.get(topicsUrl);
    return response.data.data;
  } catch (error) {
    throw new Error('Failed to get topics');
  }
}

async function uploadTemplateMedia(file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await AppService.postFile('/publish/upload', formData);

  if (!response.status === 200 || !response.data.url) {
    throw new Error('Failed to upload template media', response);
  }

  return response.data.url;
}

async function createTemplate(template) {
  return AppService.post(templatesUrl, template);
}

async function editTemplate(id, template) {
  const path = `${templatesUrl}/${id}`;

  return AppService.put(path, template);
}

async function createTopic(topic) {
  return AppService.post(topicsUrl, topic);
}

async function createSubtopic({ topicId, subtopics }) {
  const url = `${topicsUrl}/${topicId}/subtopics`;
  return AppService.post(url, { data: subtopics });
}

async function deleteTemplate(templateId) {
  const path = `${templatesUrl}/${templateId}`;
  if (!templateId) {
    throw new Error('Template ID is required for deletion');
  }
  return AppService.deleteCall(path);
}

async function endTemplates(templateIds) {
  if (!Array.isArray(templateIds) || templateIds.length === 0) {
    throw new Error('Template IDs array is required');
  }
  return AppService.post(`${templatesUrl}/end`, { ids: templateIds });
}
